import React from 'react';
import portraitImage from '../Assets/powder_brows_near_me.png';
import useSiteContent from '../hooks/useSiteContent';

export default function AboutPage() {
  const { siteContent } = useSiteContent();

  return (
    <main className="page">
      <section className="page-section page-section--intro">
        <div className="section-heading section-heading--centered">
          <span className="section-heading__eyebrow">{siteContent.about.tag}</span>
          <h1>{siteContent.about.title}</h1>
          <p>{siteContent.about.text}</p>
        </div>
      </section>

      <section className="page-section split-grid split-grid--hero">
        <article className="content-card content-card--side-image">
          <img src={portraitImage} alt={siteContent.about.title} className="content-card__image content-card__image--portrait" />
          <div className="content-card__body">
            {siteContent.about.paragraphs.map((paragraph) => (
              <p key={paragraph}>{paragraph}</p>
            ))}
          </div>
        </article>
      </section>

      <section className="page-section">
        <div className="card-grid card-grid--3">
          {siteContent.about.values.map((value) => (
            <div key={value.title} className="content-card">
              <div className="content-card__body">
                <h3>{value.title}</h3>
                <p>{value.text}</p>
              </div>
            </div>
          ))}
        </div>
      </section>
    </main>
  );
}
